import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import {
  useIsBuildingGroupProfileNGAvailable,
  useLinkLikeClick,
} from '../../../hooks'
import { getBuildingGroupProfilePathname } from '../../../utils/link'
import { ListItem } from '../../ListItem'

import { isNeedToShowBuildingGroupItemIcons } from './ProfileBuildingGroupsWidgetItem.utils'

import * as styles from './ProfileBuildingGroupsWidgetItem.module.css'

import BuildingGroupIcon from '../../../icons/buildings-group.svg'

function ProfileBuildingGroupsWidgetItem({
  className = styles.ProfileBuildingGroupsWidgetItem,
  hoverClassName = styles.hover,
  isNeedToShowIcons = isNeedToShowBuildingGroupItemIcons,
  value,
  ...restProps
}) {
  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const isBuildingGroupProfileNGAvailable =
    useIsBuildingGroupProfileNGAvailable()

  const link = getBuildingGroupProfilePathname({
    id: value,
    isBuildingGroupProfileNGAvailable,
  })

  function handleClickBuildingGroup(_value, event) {
    handleClick({
      event,
      link,
      // Webapp fallback keeps opening in a new tab; NG profile navigates in-app.
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
    })
  }

  function handleMouseDownBuildingGroup(_value, event) {
    handleMouseDown({ event, link })
  }

  return (
    <ListItem
      {...restProps}
      ListIcon={BuildingGroupIcon}
      className={className}
      hoverClassName={hoverClassName}
      isNeedToShowIcons={isNeedToShowIcons}
      textClassName={styles.text}
      tooltipProps={{ placement: FLOATING_ELEMENT_PLACEMENT.top }}
      value={value}
      onClick={handleClickBuildingGroup}
      onMouseDown={handleMouseDownBuildingGroup}
    />
  )
}

export default ProfileBuildingGroupsWidgetItem
